import React, { useLayoutEffect } from 'react';

import { Layout, Typography } from 'antd';

const { Content } = Layout;
const { Title } = Typography;

const TermsOfServicePage = () => {
  useLayoutEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }

    const { theme: previousTheme } = document.documentElement.dataset;
    document.documentElement.dataset.theme = 'dark';

    return () => {
      if (previousTheme) {
        document.documentElement.dataset.theme = previousTheme;
        return;
      }

      delete document.documentElement.dataset.theme;
    };
  }, []);

  return (
    <Layout className="legal-page">
      <Content className="legal-page__content">
        <Title level={1} className="legal-page__title">
          Terms of Service
        </Title>

        <p className="c6">
          <span className="c1">Last Updated June 10, 2026</span>
        </p>
        <p className="c6">
          <span className="c1">
            Welcome to neuralnetworkmarket.com, a data provider platform (the
            &quot;Website&quot;) operated by Neuralnetworkmarket, a Delaware
            corporation (&ldquo;Neuralnetworkmarket&rdquo;, &ldquo;we&rdquo;,
            &ldquo;our&rdquo;, or &ldquo;us&rdquo;). The Website enables users
            of the Website (&ldquo;Users&rdquo;) to learn more about us and use
            certain of our baseline Products (as hereinafter defined) offered
            for free through the Website and Users who purchase or otherwise
            register for a subscription (&ldquo;Subscribers&rdquo;) to download
            and use certain additional of our APIs, SDKs, code snippets and
            other of our data products (collectively, the
            &ldquo;Products&rdquo;) offered through the Website. This Terms of
            Service for the Website (this &ldquo;Agreement&rdquo;) sets forth
            the terms and conditions which govern your use of the Website. The
            term &ldquo;you&rdquo; and &ldquo;your&rdquo; shall refer to Users
            and/or Subscribers, as applicable. For clarity, all references to
            the &ldquo;Website&rdquo; in this Agreement will include the
            Products and any additional mention of the Products in combination
            with the Website shall be made out of the abundance of clarity for
            the particular context given.
          </span>
        </p>
        <ul className="c8 lst-kix_prh2tuf25b5g-0 start">
          <li className="c0 li-bullet-0">
            <span className="c3 c2">1. This Agreement.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c2">1.1 Acceptance via the Website.</span>
            <span className="c1">
              Please read this Agreement carefully before otherwise accessing
              the Website. In order to use the Website, you must first agree to
              be bound by the provisions of this Agreement. For Users who are
              anonymous browsers or who have not yet registered with us, by
              accessing the Website you indicate that you have read, understood
              and agree to be bound by the provisions set forth in this
              Agreement. And for Subscribers who register with us, you indicate
              your agreement to the provisions of this Agreement by means of
              such registration. If you do not agree to be bound by this
              Agreement, you are not authorized to use the Website. Furthermore,
              you are not authorized to use the Website if you are barred from
              using the Website either (a) under the laws of the jurisdiction in
              which you reside or from which you are attempting to access the
              Website, or (b) due to prior violations of this Agreement.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">1.2 Minors.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              If you are a minor in your state of residence, then you are not
              authorized to use the Website and thus you agree to use the
              Website if and only if (a) you have secured the authorization of
              your parent or legal guardian to use the Website and your parent
              or legal guardian has agreed to this Agreement on your behalf, (b)
              your parent or legal guardian has not revoked such agreement, and
              (c) you have agreed to the provisions of this Agreement and you
              have not revoked such agreement.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">1.3 Modification.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              We reserve the right to modify this Agreement at any time. You
              shall periodically review this Agreement to be aware of such
              modifications. You further agree that your continued use of the
              Website after any such modifications have been made shall be
              deemed to be your conclusive acceptance of any modified version of
              this Agreement. We will indicate that changes to this Agreement
              have been made by updating the date indicated after &quot;Last
              Updated&quot; at the beginning of this Agreement. We will be happy
              to provide you with prior versions of this Agreement upon your
              written request to us. If you do not agree to abide by the initial
              version and each modified version of this Agreement, then you are
              not authorized to use the Website . A current version of this
              Agreement is accessible via the footer of the Website&rsquo;s
              homepage.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">2. SPECIFIC DISCLAIMERS</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">2.1 NO WARRANTIES OF CONTENT.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              THE DATA ACCESSIBLE BY MEANS OF THE PRODUCTS IS RECEIVED DIRECTLY
              FROM, OR IS OTHERWISE INDIRECTLTY BASED ON, THIRD PARTY SOURCES,
              AND WE CANNOT AND DO NOT MAKE ANY REPRESENTATIONS OR WARRANTIES
              ABOUT THE ACCURACY, QUALITY OR UTILITY OF ANY DATA (AS DEFINED IN
              SECTION 4.1) CONTAINED IN OR ACESSIBLE BY USING OUR PRODUCTS AND
              ANY OTHER INFORMATION APPEARING ON THE WEBSITE OR OTHERWISE
              PROVIDED TO YOU BY US (COLLECTIVELY,&quot;CONTENT&quot;). NEITHER
              NeuralnetworkmarketNOR ANY OF OUR SHAREHOLDERS, DIRECTORS,
              OFFICERS, LICENSORS, AGENTS, EMPLOYEES, CONSULTANTS OR
              REPRESENTATIVES (COLLECTIVELY, THE
              &quot;NeuralnetworkmarketPARTIES&quot;) (A) WARRANTS THE ACCURACY,
              COMPLETENESS OR FITNESS OF PURPOSE OF ANY CONTENT, OR (B)
              PROMISES, GUARANTEES OR IMPLIES THAT ANY CONTENT WILL BE TO YOUR
              BENEFIT. YOU SHOULD NEVER RELY ON ANY CONTENT FOR ANY FINANCIAL,
              INVESTMENT OR OTHER DECISIONS THAT YOU MAKE OR OTHERWISE. ALL
              CONTENT IS INTENDED FOR INFORMATIONAL PURPOSES ONLY AND SHOULD NOT
              BE CONSTRUED AS LEGAL, FINANCIAL, INVESTMENT, BUSINESS OR OTHER
              ADVICE. NONE OF THE NeuralnetworkmarketPARTIES IS, OR IS ACTING IN
              THE CAPACITY OF, A LICENSED FINANCIAL ADVISOR, INVESTMENT ADVISOR,
              BROKER-DEALER, LAWYER, ACCOUNTANT OR ANY OTHER LICENSED OR
              REGISTERED (OR UNLICENSED OR UNREGISTERED) ADVISOR. WE DO NOT
              WARRANT OR REPRESENT OR WARRANT THAT ANY CONTENT WILL MEET YOUR
              EXPECTATIONS, OR THAT ANY ERRORS APPEARING IN ANY CONTENT (OR
              OTHERWISE ON THE WEBSITE) WILL BE DISCOVERED OR CORRECTED. WE
              RESERVE THE RIGHT, BUT ARE NOT OBLIGATED, TO LIMIT OR DISCONTINUE
              THE PROVISION OF ANY CONTENT OR OTHERWISE OUR PRODUCTS TO ANY
              PERSON, GEOGRAPHIC REGION OR JURISDICTION, OR OTHERWISE, AND WE
              MAY EXERCISE THIS RIGHT ON A CASE-BY-CASE BASIS IN OUR SOLE
              DISCRETION. THE OFFER OF SUBSCRIPTION MADE THROUGH THE WEBSITE IS
              VOID WHERE PROHIBITED.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">2.2 NO ENDORSEMENT.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c11">Neuralnetworkmarket</span>
            <span className="c1">
              IS NEITHER AFFILIATED WITH, NOR SPONSORED OR ENDORSED BY, ANY
              THIRD PARTY SOURCE OF THE CONTENT, AND THE OWNERS OF ANY THIRD
              PARTY CONTENT ARE NOT SPONSORS OF AND DO NOT ENDORSE
              Neuralnetworkmarket. NO CONTENT CONSTITUTES, OR SHOULD BE
              UNDERSTOOD AS CONSTITUTING, A SOLICITATION, RECOMMENDATION,
              PROMOTION, ENDORSEMENT OR OFFER BY ANY OF THE
              NeuralnetworkmarketPARTIES OF ANY PARTICULAR ASSET, INVESTMENT,
              TRANSACTION, PROJECT OR OPPORTUNITY.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">3. Purchase of Subscriptions.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">3.1 Subscriptions.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              Access to certain features of the Products requires you to
              purchase a subscription from us (&quot;Subscription&quot;) or
              otherwise to register with us for a Free Plan (as hereinafter
              defined). If you purchase a Subscription, you will be charged the
              applicable recurring Subscription fee indicated at the time you
              select your Subscription, plus all applicable taxes and other
              charges (collectively, the &quot;Subscription Fees&quot;), upon
              commencement of your Subscription and at the beginning of each
              interval applicable to your Subscription (e.g., on a monthly,
              quarterly or annual basis) selected by you (the &quot;Subscription
              Term&quot;) and thereafter at the then-current rate. By purchasing
              a Subscription to any of the Products, you acknowledge that your
              Subscription has recurring payment features during the
              Subscription Term, and you accept responsibility for all recurring
              payment obligations prior to written cancellation of your
              Subscription by you or cancellation by Neuralnetworkmarket. Your
              Subscription shall continue for the period indicated and pursuant
              to all applicable auto-renewals until cancelled in writing by you,
              or until we terminate your Subscription or otherwise terminate
              your access to or use of the Products in accordance with this
              Agreement. Please note that we also offer one type of Subscription
              which is free of charge (the &ldquo;Free Plan&rdquo;), but which
              has very limited usage rights ascribed to it (see further the
              limitations of such a Subscription option in Section 4 below).
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">3.2 Payment.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              When you purchase a Subscription, we will ask you to supply
              payment information relevant to your purchase, including your
              credit card number, the expiration date of your credit card and
              your email and postal addresses for billing and notification (such
              information, &quot;Payment Information&quot;). You represent and
              warrant that you (a) will provide us (or our third-party payment
              processor) with full and accurate Payment Information and (b) will
              update all Payment Information promptly as needed, and (c) have
              the legal right to use all payment methods and to authorize all
              amounts charged which are indicated by any such Payment
              Information. When you purchase a Subscription, you authorize us to
              provide your Payment Information to third parties so we can
              complete your purchase and to charge your payment method for the
              Subscription Fees, and specifically you expressly authorize us
              (and any third-party payment processor we may use) to charge you
              for your purchase. Thereafter, we (or our third-party payment
              processor) will automatically charge you at the frequency of your
              Subscription, using the Payment Information you have provided
              until the end of the applicable term in which you cancel (or we
              terminate) your Subscription, and subject to our &quot;no
              refund&quot; policy below. For annual subscriptions,
              Neuralnetworkmarketwill endeavor to send you a reminder at least
              thirty (30) days prior to each renewal with the then-current
              Subscription Fees. You may need to provide additional Payment
              Information in order to verify your identity before completing
              your renewal purchase. Your right to your Subscription is
              conditional on our receipt of the appropriate full payment of all
              Subscription Fees for such Subscription. If any such Subscription
              Fees cannot be charged to your credit card or if a charge is
              refunded for any reason, including chargeback, we reserve the
              right to cancel your Subscription immediately. Again, you are
              fully responsible for all charges made under your name.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">
              3.3 Cancelling One-Time Payment or Subscription.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              You may cancel your Subscription at any time by providing us
              written notice of same as indicated below, but please note that
              such cancellation will be effective only at the end of the
              then-current Subscription term. Unless otherwise specified at the
              time of purchase, YOU WILL NOT RECEIVE A REFUND OF ANY PORTION OF
              THE SUBSCRIPTION FEES PAID FOR THE THEN CURRENT SUBSCRIPTION
              PERIOD AT THE TIME OF CANCELLATION. You may notify us of your
              desire to cancel your subscription at any time by providing such a
              notice through neuralnetworkmarket.com/account, or by sending an
              email to support@neuralnetworkmarket.com. You will be responsible
              for all Subscription Fees (plus all applicable taxes and other
              charges) incurred for the then-current Subscription period. If you
              cancel your Subscription, your right to use the Products will
              continue through the expiration of your then current Subscription
              term.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">3.4 Your Personal Information.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              In the event you wish to purchase a Subscription, you also will be
              asked by Neuralnetworkmarketor a third party working on our behalf
              (in addition to your Payment Information) to supply certain of
              your personally identifiable information (&quot;PII&quot;) to us.
              You shall provide us or such third party (as applicable) with
              accurate, complete and current PII (including without limitation
              your email address and credit card number and expiration date),
              and you shall update all PII so provided or so requested if and as
              soon as such information changes before you make any purchase of
              any such services. You shall be responsible for any activity
              conducted through the Website which is identified with such
              information.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">3.5 Taxes.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              You are responsible for paying all applicable taxes arising out of
              any purchase made by you through the Website or otherwise.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">3.6 No Returns.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              For clarity, there are no returns, refunds or exchanges for any
              Subscription. All of the Products are provided to you strictly
              &quot;AS IS&quot;, &quot;WHERE IS&quot;, and &quot;AS
              AVAILABLE&quot;.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">4. License; Usage Restrictions.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c2">
              4.1 Grant of License to Subscribers who Purchase a Subscription.
            </span>
            <span className="c1">
              &nbsp;Neuralnetworkmarkethereby grants to each Subscriber who
              purchases a Subscription that is not a Free Plan during the
              applicable Subscription Term a non-exclusive, nontransferable,
              revocable (in the event of a breach by Subscriber) and limited
              license, subject to the usage restrictions described below in this
              Section 4.1 and further in Section 4.3, to: (a) access, view and
              manipulate data included in any of the Products
              (&quot;Data&quot;), (b) create derivative works from Data for
              Subscriber&rsquo;s own purposes (such as creating dashboards,
              rankings and other like works), (c) generate derived data from the
              Data provided to such Subscriber (&quot;Derived Data&quot;), and
              (d) enable Subscriber&rsquo;s own uses to view the Data and the
              Derived Data. Notwithstanding anything to the contrary in this
              Section 4.1 or otherwise in this Agreement, Subscriber (i)
              acknowledges that the foregoing grant of rights memorialized in
              Section 4.1(a), (b) and (c) above is to Subscriber only, and that
              the foregoing grant of rights permits users of Subscriber only to
              view the Data and/or Derived Data in the format provided by
              Subscriber, but not to manipulate the Data and/or Derived Data or
              otherwise to utilize any of the Data or Derived Data in any other
              manner, and (ii) agrees to restrict its users in writing from any
              prohibited use of the Data and/or Derived Data prior to granting
              access to the Data and/or Derived Data to such users.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c2">
              4.2 Grant of License to Subscribers who Register for a Free Plan.
            </span>
            <span className="c1">
              &nbsp;Neuralnetworkmarkethereby grants to each Subscriber who
              registers for a Free Plan during the applicable Subscription Term
              a non-exclusive, nontransferable, revocable (at any time by
              Neuralnetworkmarket) and limited license, subject to the usage
              restrictions described below in this Section 4.2 and further in
              Section 4.3, to access and view the Data, and to use the Data for
              Subscriber&rsquo;s non-commercial purposes only and without
              limiting the foregoing not to create any Derived Data.
              Furthermore, and notwithstanding anything to the contrary in this
              Section 4.2 or otherwise in this Agreement, Subscriber (i)
              acknowledges that the foregoing grant of rights memorialized in
              this Section 4.2 is to Subscriber only, and that the foregoing
              grant of rights permits users of Subscriber only to view the Data
              in the format provided by Subscriber, but not to manipulate the
              Data and/or create any Derived Data or otherwise to utilize any of
              the Data in any other manner, and (ii) agrees to restrict its
              users in writing (prior to granting such users access to any of
              the Data) from using any of the Data in any manner outside of the
              scope of license provided in this Section 4.2 and as further
              described in Section 4.3.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">4.3 Usage Restrictions.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              You shall not use the Website or any of the Products (or enable
              your users to use the Products) in any manner which:
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              (a) enables you(or enables any other person) to(i) copy, modify,
              create a derivative work of any Content (other than for Derived
              Data as described in Sections 4.1 and 4.2 above), or(ii) copy,
              modify, create a derivative work of , reverse engineer, translate,
              adapt or decompile(or attempt to translate, adapt or decompile) or
              otherwise attempt to extract any software underlying any portion
              of the Website including any of the Products or the source code of
              the software underlying the Website including any of the Products,
              or any portion thereof;
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              (b) interferes with operations or services provided by the Website
              including any of the Products or otherwise disrupts the Website
              including any of the Products in any way;
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              (c) interrupts, destroys or limit the functionality of , any
              computer software or hardware or telecommunications
              equipment(including without limitation by means of software
              viruses, Trojan horses or any other computer code, files or
              programs);
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              (d) infringes any copyright, trademark, trade secret, patent or
              other right of any party(including the promoting of an illegal or
              unauthorized copy of another person &#39;s copyrighted work), or
              defames or invades the publicity rights or the privacy of any
              person, living or deceased (or impersonates any such person);
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              (e) is false, misleading, harmful, threatening, abusive,
              harassing, tortious, defamatory, vulgar, obscene, libelous,
              hateful, or racially, ethnically or otherwise objectionable, as
              determined by us in our sole discretion;
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              (f) creates a false identity or otherwise attempts to mislead any
              person as to the identity or origin of any communication;
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              (g) exports, re - exports, or permits downloading of any message
              or content in violation of any export or import law, regulation,
              or restriction of the United States and its agencies and
              authorities, or without all required approvals, licenses, or
              exemptions;
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              (h) causes us to lose( in whole or part) the services of our
              internet service providers or other suppliers;
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              (i) consists of any unsolicited or unauthorized advertising,
              promotional materials, &quot;junk mail,&quot; &quot;spam,&quot;
              &quot;chain letters,&quot; &quot;pyramid schemes,&quot; or any
              other form of solicitation, or otherwise transmits, posts or sends
              unsolicited commercial messages, removes or modifies any postings,
              unauthorized commercial advertisements, affiliate links, and other
              forms of solicitation;
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              (j) links to materials or other content, directly or indirectly,
              to which you do not have a right to link or which we determine in
              our sole discretion is not appropriate to be linked to from the
              Website; or
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              (k) violates, or encourages others to violate this Agreement(or
              engages in any other activity deemed by us to be in conflict with
              this Agreement), or violates or encourages others to violate any
              applicable local, state, national, or international law.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">4.4 Expiration of License.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              At the expiration or earlier termination of the Subscription Term,
              you must destroy all Data (and any Derived Data which can be
              converted back to Data) then in your possession, and you shall
              provide Neuralnetworkmarketwith a written statement signed by you
              certifying to such destruction (and if you are an entity, such a
              statement shall be signed by an officer of your company).
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">4.5 Reporting Violations.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              You shall immediately notify us in writing of any Content that you
              view through the Website which you deem to be offensive,
              inappropriate or otherwise a violation of this Agreement.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">4.6 Disabling or Revocation of Use.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              We have the right to cancel or suspend your use of the Website
              including any of the Products including any purchase made by you,
              for any reason, as determined in our sole discretion, including
              without limitation if we believe you have violated this Agreement.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">5. Intellectual Property.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">5.1 Proprietary Rights.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              The Products including without limitation all Content provided by
              Neuralnetworkmarketor any of our third party licensors is
              protected by copyright, trademark and other laws of the United
              States and/or other jurisdictions. Other than for third party
              Trademarks(as hereinafter defined) appearing on the Website, you
              acknowledge and agree that as between you and us, all right, title
              and interest (including without limitation all copyright,
              trademark, patent, trade secret and other intellectual property
              rights) in and to Website (for the abundance of clarity including
              any of the Products), including without limitation all other Data
              and other Content appearing therein, is owned exclusively by us,
              and that you have no rights in and to the Website(or for the
              abundance of clarity including in any of the Products) other than
              as expressly set forth in this Agreement. Other than for the
              licenses granted in Sections 4.1 and 4.2 above and except for that
              information which is in the public domain and is not otherwise
              limited by third party rights, no Content (including all Data) or
              any software underlying the Products may be sold, copied,
              reproduced, republished, uploaded, displayed, posted, transmitted,
              distributed, modified, publicly performed, used in any derivative
              works based thereon or otherwise used for any public or commercial
              purpose without our prior written consent.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">5.2 Trademarks.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              &quot;Neuralnetworkmarket&quot; is a trademark of
              Neuralnetworkmarket. All other Trademarks referenced on the
              Website are the property of their respective owners.
              Neuralnetworkmarketis not affiliated with, or sponsored or
              endorsed by any third party trademark owner whose Trademark
              appears on the Website and whose owner is not indicated to be
              Neuralnetworkmarket. As used herein, the term
              &quot;Trademarks&quot; means, collectively, all service names,
              graphics, designs, logos, page headers, button icons, scripts,
              commercial markings, and trade dress which indicate a source of
              goods or services. Trademarks are protected by the trademark laws
              of the United States and/or other jurisdictions. You may not use,
              copy, reproduce, republish, distribute or modify any Trademarks in
              any way, including without limitation in the distribution of any
              Content, for advertising or publicity or otherwise, without our
              prior written consent or the prior written consent of such third
              party Trademark holder, as applicable. Unless you have been
              expressly authorized to do so in writing by Neuralnetworkmarketor
              any other applicable Trademark holder, you shall not use any
              Trademark of any individual or entity in a way that is likely or
              intended to cause confusion with such Trademark holder. The owners
              of any third party product, service, information, content,
              Trademark or copyright appearing on the Website are not sponsors
              of Neuralnetworkmarketand have not endorsed and are not affiliated
              with Neuralnetworkmarket, and Neuralnetworkmarketis not a sponsor
              and does not endorse any such third parties.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">5.3 Removal of Notices.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              You shall not remove, obscure, or alter any proprietary rights or
              notices (including without limitation copyright and Trademark
              notices) which may be affixed to or contained within any Content.
              You shall abide by all such notices.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">6. Links; Third Party Resources.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              The Website may provide links to third party resources which may
              be of possible interest to you. Because we do not endorse or
              otherwise have control over such resources, we are not responsible
              or liable, directly or indirectly, for (a) the availability of
              such resources, (b) any content, data, text, software, music,
              sound, photographs, video, messages, tags, links, advertising,
              services, products, or other materials on or available from such
              resources, (c) your participation, correspondence or business
              dealings with any third party found on or through the Website, (d)
              any specific goods and services provided by such parties, and any
              other terms, conditions, representations or warranties associated
              with such dealings, which are solely between you and any such
              third parties, or (e) any damage or loss caused or alleged to be
              caused by or in connection with your interaction with any such
              third party or any other third party whom you form a connection
              with through or because of the Website. Your use of any resources
              linked to from the Website is subject to the policies and
              procedures of the owner of such resource, and your use of all such
              resources is subject to such policies and procedures and not to
              the provisions of this Agreement.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">
              7. Representations, Warranties and Covenants.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              You represent and warrant that (a) you have all rights, power and
              the full legal authority to enter into this Agreement (and if you
              are entering into this Agreement on behalf of any entity that you
              are fully authorized by such entity to so enter into this
              Agreement on its behalf), (b) you have carefully read this
              Agreement and shall comply with all of your obligations under this
              Agreement and any other terms or conditions posted on the Website,
              and (c) this Agreement is enforceable against you in accordance
              with its terms and conditions.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">8. DISCLAIMER OF WARRANTIES.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              YOUR USE OF THE WEBSITE (FOR CLARITY INCLUDING WITHOUT LIMITATION
              ANY OF THE PRODUCTS) IS STRICTLY &quot;AS IS&quot;, &quot;AS
              AVAILABLE&quot;, &lsquo;&quot;WHERE AVAILABLE&quot;, AND AT YOUR
              SOLE RISK. NONE OF THE NeuralnetworkmarketPARTIES HAS OR SHALL
              HAVE ANY LIABILITY, OBLIGATION OR RESPONSIBILITY TO YOU OR ANY
              OTHER PERSON FOR ANY LOSS, DAMAGE, OR ADVERSE CONSEQUENCE ALLEGED
              TO HAVE HAPPENED OR WHICH HAS HAPPENED, DIRECTLY OR INDIRECTLY,
              THROUGH YOUR USE OF THE WEBSITE (INCLUDING ANY OF THE PRODUCTS) OR
              OTHERWISE RELATED TO YOUR SUBSCRIPTION. NeuralnetworkmarketFURTHER
              DOES NOT MAKE ANY GUARANTY OF THE ACCURACY, CORRECTNESS,
              USEFULNESS, TIMELINESS OR COMPLETENESS OF, AND IS NOT LIABLE FOR
              LOSSES OR DAMAGES ALLEGED TO ARISE FROM OR ARISING FROM OR RELATED
              TO, ANY USE OF THE WEBSITE (INCLUDING ANY OF THE PRODUCTS).
              SPECIFICALLY, AND TO THE EXTENT PERMITTED BY APPLICABLE LAW, EACH
              OF THE NeuralnetworkmarketPARTIES DISCLAIMS ANY IMPLIED WARRANTIES
              OF TITLE, NON-INFRINGEMENT, MERCHANTABILITY, AND FITNESS FOR ANY
              PARTICULAR PURPOSE REGARDING THE WEBSITE (INCLUDING ANY OF THE
              PRODUCTS) OR THAT THE WEBSITE (INCLUDING THE PRODUCTS) WILL BE
              UNINTERRUPTED OR ERROR FREE OR FREE FROM VIRUSES OR OTHER HARMFUL
              COMPONENTS. FURTHER, UNDER NO CIRCUMSTANCES SHALL
              NeuralnetworkmarketBE LIABLE IN ANY WAY FOR ANY LOSS OR DAMAGE
              ALLEGED TO ARISE OR ARISING OUT OF OR RELATED TO YOUR USE OF THE
              WEBSITE (INCLUDING ANY OF THE PRODUCTS), OR YOUR INTERACTION WITH
              ANY THIRD PARTY LINKED TO FROM THE WEBSITE OR OTHERWISE.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">9. LIMITATION OF LIABILITY.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              IN NO EVENT SHALL ANY OF THE NeuralnetworkmarketPARTIES BE LIABLE
              FOR LOST PROFITS OR FOR ANY SPECIAL, INCIDENTAL, INDIRECT,
              CONSEQUENTIAL OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO,
              DIRECTLY OR INDIRECTLY, YOUR USE OF THE WEBSITE (INCLUDING ANY OF
              THE PRODUCTS), INCLUDING WITHOUT LIMITATION YOUR LOSS OF ANY DATA,
              INCOME, OR PROFIT, OR LOSS OR DAMAGE TO PROPERTY, ARISING OUT OF
              OR RELATED TO THE USE OF, OR THE INABILITY TO USE, THE
              WEBSITE(INCLUDING ANY OF THE PRODUCTS), WHETHER OR NOT ANY OF THE
              NeuralnetworkmarketPARTIES HAS BEEN ADVISED OF THE POSSIBILITY OF
              SUCH DAMAGES. THE AGGREGATE LIABILITY OF THE
              NeuralnetworkmarketPARTIES TO YOU OR ANY THIRD PARTY IN ANY
              CIRCUMSTANCE IS LIMITED TO THE LESSER OF (A) THE SUBSCRIPTION FEES
              PAID BY YOU TO US IN THE THREE (3) MONTH PERIOD IMMEDIATELY
              PRECEDING THE ARISING OF SUCH LIABILITY, OR (B) (I) ONE HUNDRED
              DOLLARS ($100) FOR THE SUBSRIBER OF A FREE PLAN, AND (II) FIVE
              HUNDRED DOLLARS ($500) FOR ALL OTHER SUBSCRIBERS. SOME
              JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR
              THE LIMITATION OR EXCLUSION OF LIABILITY FOR SPECIAL, INCIDENTAL,
              INDIRECT, CONSEQUENTIAL OR PUNITIVE DAMAGES. ACCORDINGLY, SOME OF
              THE ABOVE LIMITATIONS IN SECTION 8 OR THIS SECTION 9 MAY NOT APPLY
              TO YOU, BUT IN SUCH A CASE ALL LIABILITY WILL BE LIMITED TO THE
              GREATEST EXTENT PERMITTED BY LAW.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">10. Indemnification.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              You shall indemnify, defend and hold harmless each of the
              NeuralnetworkmarketParties from any and all claims, demands,
              actions, causes of action and/or lawsuits (each, a
              &quot;Claim&quot; and collectively, &quot;Claims&quot;) and all
              resulting costs, liabilities, losses, expenses, and damages,
              actual and consequential, direct and indirect, of every kind and
              nature, including without limitation reasonable attorneys&#39;
              fees and disbursements (collectively, &quot;Losses&quot;) made by
              any third party arising out of or related to (a) the breach by you
              of any of your representations, warranties, covenants or
              obligations under this Agreement, (b) your negligence or
              misconduct, or (c) your violation of any law or regulation. You
              shall provide all applicable NeuralnetworkmarketParties with
              prompt written notice of any Claim or potential Claim of which you
              become aware. Upon the assertion or commencement of any Claim
              against one or more of the NeuralnetworkmarketParties by any third
              party that may give rise to liability of any such
              NeuralnetworkmarketParty hereunder, you shall assume the control
              of the defense of such Claim at your sole expense with counsel
              reasonably acceptable to each such applicable
              NeuralnetworkmarketParty; provided, however, that each such
              NeuralnetworkmarketParty may take part in and/or fully assume such
              defense, in its sole discretion and at its own expense after you
              assume the control thereof. You shall not enter into any
              settlement of any Claim which any of the
              NeuralnetworkmarketParties believes is adverse to its interests,
              without receiving the prior written consent of each of the
              NeuralnetworkmarketParties affected by such Claim. In no event
              shall any of the NeuralnetworkmarketParties be obligated to
              participate in any settlement which any such party reasonably
              believes would have an adverse effect on such party&rsquo;s
              business interests.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">11. Privacy.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c11">Neuralnetworkmarket</span>
            <span className="c1">
              views the protection of your privacy as an important
              responsibility. The terms regulating the handling, use and storage
              of your PII and other information by us in connection with the
              Website (including any of the Products) is described in our
              Privacy Policy, which can be found at
              https://neuralnetworkmarket.com/privacy (the &quot;Privacy
              Policy&quot;). By using the Website, you consent to the collection
              and use of your PII by us as described in the Privacy Policy.
              However, the handling, use and storage of your PII by any third
              party is subject to the privacy policy (if any) of such third
              party and not the Privacy Policy; for instance, when you provide
              your credit card information to our third party payment provider,
              your PII will be subject to the privacy policy of such payment
              provider and not this Privacy Policy.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">12. No Agency.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              No agency, partnership, joint venture, employee-employer or
              franchiser-franchisee relationship is intended or created between
              you and Neuralnetworkmarketby this Agreement or as a result of
              your use of the Website including any of the Products.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">13. Notices; Publicity.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              All notices hereunder shall be given by electronic mail as
              follows: to Neuralnetworkmarketat legal@neuralnetworkmarket.com
              and to a Subscriber at the email listed provided to us by such
              Subscriber upon registration. Notice shall be deemed given three
              (3) days after the date of such mailing and upon receipt of such
              email. Neuralnetworkmarketmay use your corporate name and logo for
              publicity purposes such as in connection with its client list and
              other client information.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">
              14. Governing Law; Arbitration; NO CLASS CLAIMS; TIMELY FILING OF
              CLAIMS.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              This Agreement shall be governed by and construed in accordance
              with the laws of the State of Delaware excluding Delaware
              choice-of-law principles. Any dispute arising out of or relating
              to this Agreement (including without limitation regarding any
              breach hereunder), or your use of the Website including any of the
              Products, shall be finally resolved by binding arbitration
              administered by the American Arbitration Association under its
              Commercial Arbitration Rules (the &quot;CAB&quot;) but if the AAA
              does not agree to adjudicate such dispute under the CAB then by a
              private professional arbitrator and associated rules determined
              reasonably agreed upon by the parties in writing. Judgment upon
              the award rendered by the arbitrator may be entered in any court
              having jurisdiction. The arbitration will be conducted in New
              York, NY by an arbitrator with applicable expertise in data
              subscription industry, who shall be named in accordance with such
              rules. The award of the arbitrator shall be final and binding on
              you and us, without a right of appeal, and shall be accompanied by
              a statement of the reasons upon which the award is based, and such
              statement as well as all information concerning such arbitration
              proceedings including without limitation all evidence and
              materials submitted by you and/or us shall be deemed to be
              confidential information and shall not be made public by either
              you or us. If the party who initiates the arbitration action is
              unsuccessful to all claims raised, then such party shall pay the
              other party&rsquo;s costs and expenses associated with such
              arbitration, including but not limited to the other party&rsquo;s
              reasonable attorneys&rsquo; fees. NO ARBITRATION OR CLAIM UNDER
              THIS AGREEMENT SHALL BE JOINED TO ANY OTHER ARBITRATION OR CLAIM,
              AND NO CLASS ARBITRATION PROCEEDINGS SHALL BE PERMITTED AND YOU
              HEREBY WAIVE YOUR RIGHTS TO BRING ANY SUCH CLAIM. Notwithstanding
              the foregoing, you and we may each apply to any court of competent
              jurisdiction for injunctive relief or for enforcement of this
              arbitration provision, without breach of this arbitration
              provision. YOU AGREE THAT REGARDLESS OF ANY STATUTE OR LAW TO THE
              CONTRARY, ANY CLAIM THAT YOU MAY HAVE AGAINST ANY OF THE
              NeuralnetworkmarketPARTIES WHICH ARISES OUT OF OR IS RELATED TO
              THIS AGREEMENT OR OTHERWISE RELATED YOUR USE OF THE WEBSITE
              INCLUDING ANY OF THE PRODUCTS, MUST BE FILED BY YOU PURSUANT TO
              THIS SECTION 14 WITHIN ONE (1) YEAR AFTER SUCH CLAIM OR CAUSE OF
              ACTION AROSE OR IS CLAIMED TO HAVE ARISEN.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">15. Assignment.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              You shall not resell or assign your rights, duties or obligations
              under this Agreement and any attempted assignment or delegation
              will be void ad initio and of no force or effect whatsoever. This
              Agreement may be automatically assigned by Neuralnetworkmarket, in
              our sole discretion, to a third party, and such an assignment will
              inure to the benefit of our successors, assigns and/or licensees.
              Without limitation of the foregoing, we may sell, transfer or
              otherwise share some or all of our assets, including without
              limitation your PII, with any parent company, subsidiary, joint
              venture, and a company under our common control, as well as with a
              potential acquirer, including without limitation in connection
              with a merger, reorganization, or sale of assets, or in the event
              of bankruptcy. In each such an event, the PII we have collected
              from you may be one of the assets transferred.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">16. Force Majeure.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              In addition to any excuse provided by applicable law and
              notwithstanding anything to the contrary in this Agreement,
              Neuralnetworkmarketshall be excused from liability for
              non-delivery or delay in delivery the Products (including without
              limitation any Data delivered through the Products) arising from
              or related to any cause or event beyond our reasonable control,
              whether or not foreseeable by either party and whether or not
              similar to any of the following described causes or events,
              including but not limited to: labor disturbance, war, fire,
              accident, adverse weather, electrical outage, loss of data from
              any exchanges/networks or other of our data sources, Internet
              delay or failure, inability to secure transportation, governmental
              act or regulation.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">17. No Waiver.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              Our failure to act with respect to a breach by you or others does
              not waive our right to act with respect to a subsequent or similar
              breach or breaches. If Neuralnetworkmarketdoes not exercise or
              enforce any legal right or remedy which is contained in this
              Agreement (or which Neuralnetworkmarkethas the benefit of under
              any applicable law or regulation), such action or inaction shall
              not be taken to be a formal waiver of Neuralnetworkmarket&rsquo;s
              rights, and all such rights or remedies shall still be available
              to Neuralnetworkmarket.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">18. Validity.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              If any provision of this Agreement is held to be invalid by a
              court having competent jurisdiction, the invalidity of such
              provision shall not affect the validity of the remaining
              provisions of this Agreement, which shall remain in full force and
              effect. Section headings are for reference purposes only and in no
              way define, limit, construe or describe the scope or extent of
              such section. This Agreement and any ancillary terms and
              conditions referenced herein sets forth the entire understanding
              and agreement between you and us with respect to the subject
              matter hereof. The provisions of this Agreement shall survive
              termination or expiration to the extent necessary to carry out the
              obligations of you and Neuralnetworkmarkethereunder.
            </span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c3 c2">19. Contact Us.</span>
          </li>
          <li className="c0 li-bullet-0">
            <span className="c1">
              If you have any questions or concerns regarding the Website
              including any of the Products, please contact us by e-mail at
              support@neuralnetworkmarket.com.
            </span>
          </li>
        </ul>
        <p className="c4 c22">
          <span className="c3 c12"></span>
        </p>
        <p className="c4 c22">
          <span className="c3 c12"></span>
        </p>
      </Content>
    </Layout>
  );
};

export default TermsOfServicePage;
